module.exports = new __parcel__URL__("tm54dvar-ch4flux-monthgrid-v1.thumbnails.fossil.56040fa6.png").toString();